import {
  defSimpleUnit,
  defAlias,
  defInvertedUnit,
  defBaseUnit,
} from '../registry';

// These are weird units that are only useful as a component of
// another unit.  I suspect the Lscript lexer would choke on them
// if they were used as a standalone unit.
defSimpleUnit('10km', 'meter', 10000);
defSimpleUnit('9000m', 'meter', 9000);

export const textileUnits = [
  defBaseUnit('number_metric', 'meter/gram'),
  defSimpleUnit('number_english', 'number_metric', 1.6933644),
  defInvertedUnit('tex', 'gram/km', 'number_metric', 1000),
  defInvertedUnit('decitex', 'gram/10km', 'number_metric', 10000),
  defInvertedUnit('denier', 'gram/9000m', 'number_metric', 9000),
];

defAlias('dtex', 'decitex');
